"use client";

import {
  SkeletonBox,
  SkeletonContainer,
  SkeletonField,
  SkeletonLabel,
} from "@/components/ui/skeleton";

const INPUT_SKELETON = "h-9 w-full rounded-lg";

export function OnboardingPageSkeleton() {
  return (
    <SkeletonContainer className="flex w-full max-w-full flex-col overflow-hidden md:h-[654px] md:max-w-[1038px] md:flex-none md:flex-row md:rounded-xl md:border border-contrast/8">
      <div className="flex w-full flex-1 min-h-0 items-start justify-center overflow-y-auto bg-surface-elevated md:w-[519px] md:flex-none md:shrink-0 md:items-center md:overflow-hidden">
        <div className="flex w-full max-w-[447px] md:w-[447px] min-h-full md:min-h-0 md:h-[576px] flex-col justify-between px-6 md:px-0 py-8 md:py-0">
          <div className="flex shrink-0 flex-col gap-1">
            <div className="flex items-center gap-0.5">
              <SkeletonLabel className="h-5 w-9 rounded" />
              <SkeletonBox className="size-3.5 shrink-0 rounded opacity-60" />
              <SkeletonLabel className="h-5 w-24 rounded" />
            </div>
            <SkeletonBox className="h-8 w-full max-w-[380px] rounded-md" />
          </div>

          <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-hidden pt-4">
            <div className="flex shrink-0 items-center gap-5">
              <SkeletonBox className="size-20 shrink-0 rounded-full" />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <SkeletonLabel className="w-28" />
                <SkeletonBox className="h-8 w-[132px] rounded-md" />
                <SkeletonLabel
                  tone="muted"
                  className="h-3 w-full max-w-[260px]"
                />
              </div>
            </div>

            <div className="flex shrink-0 gap-3">
              <SkeletonField
                className="min-w-0 flex-1 gap-2"
                inputClassName={INPUT_SKELETON}
              />
              <SkeletonField
                className="min-w-0 flex-1 gap-2"
                inputClassName={INPUT_SKELETON}
              />
            </div>

            <SkeletonField
              className="shrink-0 gap-2"
              inputClassName={INPUT_SKELETON}
            />
            <SkeletonField
              className="shrink-0 gap-2"
              inputClassName={INPUT_SKELETON}
            />

            <div className="flex shrink-0 flex-col gap-2">
              <SkeletonLabel className="w-28" />
              <SkeletonBox
                tone="muted"
                className={`w-full ${INPUT_SKELETON}`}
              />
            </div>
          </div>

          <div className="flex shrink-0 flex-col gap-3 pt-4">
            <SkeletonBox className="h-8 w-full rounded-md" />
          </div>
        </div>
      </div>

      <div className="hidden h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-surface-secondary md:flex">
        <SkeletonBox
          tone="muted"
          className="h-full min-h-0 w-full flex-1 rounded-none"
        />
      </div>
    </SkeletonContainer>
  );
}
